import React, { useEffect } from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft, Download, FileText } from "lucide-react";
import { IMPEGNO_POLITICO_TEMI } from "@/data/impegnoPoliticoData";

export default function ImpegnoPoliticoDettaglioPage() {
  const { slug } = useParams();
  const tema = IMPEGNO_POLITICO_TEMI.find((t) => t.slug === slug);

  useEffect(() => {
    if (tema) {
      document.title = `${tema.titolo} | Confcommercio Roma`;
    }
    window.scrollTo(0, 0);
  }, [tema]);

  if (!tema) {
    return <Navigate to="/chi-siamo/impegno-politico" replace />;
  }

  return (
    <main id="main-content" data-testid={`impegno-politico-dettaglio-${tema.slug}`} className="bg-white">
      {/* Hero con cover */}
      <section className="relative h-[300px] md:h-[380px] overflow-hidden">
        <img src={tema.cover} alt={tema.titolo} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(4, 30, 66, 0.82)" }} />
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative h-full flex flex-col justify-end pb-10">
          <Link
            to="/chi-siamo/impegno-politico"
            className="inline-flex items-center gap-2 text-sm text-white/80 hover:text-white mb-4"
            data-testid="impegno-back"
          >
            <ArrowLeft size={16} /> Torna a Il Nostro Impegno
          </Link>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">
            Il Nostro Impegno
          </span>
          <h1 className="text-3xl md:text-4xl font-bold text-white mt-2 font-['Encode_Sans_Semi_Condensed'] tracking-tight leading-tight">
            {tema.titolo}
          </h1>
          <p className="text-base md:text-lg text-white/85 mt-2 font-['Encode_Sans_Semi_Condensed']">
            {tema.sottotitolo}
          </p>
        </div>
      </section>

      {/* Corpo */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="prose prose-lg max-w-none">
          {tema.corpo.map((p, idx) => (
            <p
              key={idx}
              className="text-[var(--confcom-text-secondary)] leading-relaxed mb-5"
            >
              {p}
            </p>
          ))}
        </div>

        {/* Download PDF */}
        <div
          className="mt-10 rounded-2xl border border-[var(--confcom-border)] bg-[#EBF5FF] p-6 md:p-7 flex flex-col sm:flex-row items-start sm:items-center gap-5"
          data-testid="impegno-pdf-box"
        >
          <div className="w-14 h-14 rounded-xl bg-white flex items-center justify-center shrink-0 border border-[var(--confcom-blue)]/15">
            <FileText size={24} className="text-[var(--confcom-blue)]" aria-hidden="true" />
          </div>
          <div className="flex-1">
            <p className="text-xs font-bold uppercase tracking-[0.15em] text-[var(--confcom-blue)] mb-1">
              Documento integrale
            </p>
            <p className="text-base font-semibold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] leading-snug">
              {tema.titolo}
            </p>
            <p className="text-sm text-[var(--confcom-text-secondary)] mt-0.5">{tema.sottotitolo}</p>
          </div>
          {tema.pdfUrl ? (
            <a
              href={tema.pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              download
              data-testid="impegno-pdf-download"
              className="inline-flex items-center gap-2 rounded-lg bg-[var(--confcom-blue)] text-white text-sm font-semibold px-5 py-2.5 hover:opacity-90 transition-opacity shrink-0"
            >
              <Download size={16} /> Scarica il PDF
            </a>
          ) : (
            <span
              data-testid="impegno-pdf-unavailable"
              className="inline-flex items-center gap-2 rounded-lg border border-[var(--confcom-border)] bg-white text-[var(--confcom-text-muted)] text-sm font-semibold px-5 py-2.5 shrink-0 cursor-not-allowed"
            >
              <FileText size={16} /> PDF in preparazione
            </span>
          )}
        </div>
      </section>
    </main>
  );
}
